import { AxiosResponse } from 'axios';

export function getData(response: AxiosResponse<any>) {
  return response.data;
}
